import styled from 'styled-components'
import React from 'react'
import {BrowserRouter , Routes , Route } from 'react-router-dom'

import Navbar from './components/ui/Navbar'
import Footer from './components/ui/Footer'

//screens
import Home from './components/screens/Home'
import Gallery from './components/screens/Gallery'
import AdminLogin from './components/screens/AdminLogin'
import Contact from './components/screens/Contact'

const AppStyled = styled.div`
  padding: 5px;
  

`

const App = () => {

  return (
    <AppStyled>
      <BrowserRouter>
        <Navbar/>
        <Routes>
          <Route
            exact path ='/'
            element={<Home />}
          />
          <Route
            exact path ='/gallery'
            element={<Gallery />}
          />
          <Route
            exact path ='/admin'
            element={<AdminLogin  />}
          />
          <Route
            exact path ='/contact'
            element={<Contact  />}
          />
        </Routes>
        <Footer/>
      </BrowserRouter>
    </AppStyled>    
  )
}

export default App